/** Entry point: mount the app and register the offline service worker. */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('missing #root');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// The app has no server to talk to, so a cached build is a complete app —
// which is what makes it usable on a phone with no signal.
registerSW({ immediate: true });
